// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__33Gtw","resendInfoText":"OnGoingPaymentBox_resendInfoText__1hKLW"};